export * as taxCalculationProvider from '@wix/auto_sdk_ecom_tax-calculation-provider';
export * as giftVouchersProvider from '@wix/auto_sdk_ecom_gift-vouchers-provider';
export * as memberships from '@wix/auto_sdk_ecom_memberships';
export * as recommendationsProvider from '@wix/auto_sdk_ecom_recommendations-provider';
export * as shippingRates from '@wix/auto_sdk_ecom_shipping-rates';
export * as additionalFees from '@wix/auto_sdk_ecom_additional-fees';
export * as catalog from '@wix/auto_sdk_ecom_catalog';
export * as customTriggers from '@wix/auto_sdk_ecom_custom-triggers';
export * as discounts from '@wix/auto_sdk_ecom_discounts';
export * as inventory from '@wix/auto_sdk_ecom_inventory';
export * as paymentSettings from '@wix/auto_sdk_ecom_payment-settings';
export * as validations from '@wix/auto_sdk_ecom_validations';